var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.getStatusCalcinacaoClass(_vm.statusCalcinacao)},[_vm._v(" "+_vm._s(_vm.getStatusCalcinacaoNome(_vm.statusCalcinacao))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }